const newDemand = [{
        path: "/personQuery",
        name: "personQuery",
        component: () =>
            import ("@/views/newDemand/personQuery.vue"),
        meta: {
            title: "青年人才购房券查询"
        }
    },
    {
        path: "/personPublicity",
        name: "personPublicity",
        component: () =>
            import ("@/views/newDemand/personPublicity.vue"),
        meta: {
            title: "青年人才购房券公示"
        }
    },
    {
        path: "/buyOldHouse",
        name: "buyOldHouse",
        component: () =>
            import ("@/views/newDemand/buyOldHouse.vue"),
        meta: {
            title: "我要买二手房"
        }
    }, {
        path: "/sellers",
        name: "sellers",
        component: () =>
            import ("@/views/newDemand/sellers.vue"),
        meta: {
            title: "我要卖房"
        }
    },
    {
        path: "/calculator",
        name: "calculator",
        component: () =>
            import ("@/views/newDemand/calculator.vue"),
        meta: {
            title: "房贷计算器"
        }
    },
    {
        path: "/yanxuanList",
        name: "yanxuanList",
        component: () =>
            import ("@/views/newDemand/yanxuanList.vue"),
        meta: {
            title: "严选好房"
        }
    },
    {
        path: "/jump",
        name: "jump",
        component: () =>
            import ("@/views/newDemand/jump.vue"),
    },
    {
        path: "/Insurance",
        name: "Insurance",
        component: () =>
            import ("@/views/newDemand/Insurance.vue"),
        meta: {
            title: "家财保障"
        }
    },
    {
        path: "/calculatorDetail",
        name: "calculatorDetail",
        component: () =>
            import ("@/views/newDemand/calculatorDetail.vue"),
        meta: {
            title: "商业贷款"
        }
    }, {
        path: "/taxation",
        name: "taxation",
        component: () =>
            import ("@/views/newDemand/taxation.vue"),
        meta: {
            title: "税费计算器 "
        }
    }, {
        path: "/mortgageRegistration",
        name: "mortgageRegistration",
        component: () =>
            import ("@/views/newDemand/mortgageRegistration.vue"),
        meta: {
            title: "房贷预报名 "
        }
    }, {
        path: "/taxationDetail",
        name: "taxationDetail",
        component: () =>
            import ("@/views/newDemand/taxationDetail.vue"),
        meta: {
            title: "税费计算器结果页 "
        }
    },
    {
        path: "/bankLoans",
        name: "bankLoans",
        component: () =>
            import ("@/views/newDemand/bankLoans.vue"),
        meta: {
            title: "咨询详情"
        }
    },
    {
        path: "/bankkfList",
        name: "bankkfList",
        component: () =>
            import ("@/views/newDemand/bankkfList.vue"),
        meta: {
            title: "咨询详情"
        }
    },
    {
        path: "/bankLoansDetail",
        name: "bankLoansDetail",
        component: () =>
            import ("@/views/newDemand/bankLoansDetail.vue"),
        meta: {
            title: "详情 "
        }
    },

    {
        path: "/repayment",
        name: "repayment",
        component: () =>
            import ("@/views/newDemand/repayment.vue"),
        meta: {
            title: "提前还款计算器"
        }
    },
    {
        path: "/repaymentDetail",
        name: "repaymentDetail",
        component: () =>
            import ("@/views/newDemand/repaymentDetail.vue"),
        meta: {
            title: "还清结果页"
        }
    },
    {
        path: "/qrCode",
        name: "qrCode",
        component: () =>
            import ("@/views/newDemand/qrCode.vue"),
        meta: {
            title: "二维码"
        }
    },
    {
        path: "/assessment",
        name: "assessment",
        component: () =>
            import ("@/views/newDemand/assessment.vue"),
        meta: {
            title: "购房能力评估"
        }
    },
    {
        path: "/assessmentDetail",
        name: "assessmentDetail",
        component: () =>
            import ("@/views/newDemand/assessmentDetail.vue"),
        meta: {
            title: "评估结果"
        }
    },
    {
        path: "/property",
        name: "property",
        component: () =>
            import ("@/views/newDemand/property.vue"),
        meta: {
            title: "投诉查询",
            isLogin: true
        }

    },
    {
        path: "/newComplaints",
        name: "newComplaints",
        component: () =>
            import ("@/views/newDemand/newComplaints.vue"),
        meta: {
            title: "新增投诉",
            isLogin: true
        }

    },
    {
        path: "/vote",
        name: "vote",
        component: () =>
            import ("@/views/newDemand/vote.vue"),
        meta: {
            title: "中国·徐州 房地产行业 颁奖盛典"
        }

    },
    {
        path: "/voteList",
        name: "voteList",
        component: () =>
            import ("@/views/newDemand/voteList.vue"),
        meta: {
            title: "中国·徐州 房地产行业 颁奖盛典"
        }
    },
    {
        path: "/integral",
        name: "integral",
        component: () =>
            import ("@/views/newDemand/integral.vue"),
        meta: {
            title: "积分首页"
        }
    },
    {
        path: "/integralTask",
        name: "integralTask",
        component: () =>
            import ("@/views/newDemand/integralTask.vue"),
        meta: {
            title: "积分首页"
        }
    },
    {
        path: "/commodityDetail",
        name: "commodityDetail",
        component: () =>
            import ("@/views/newDemand/commodityDetail.vue"),
        meta: {
            title: "积分首页"
        }
    },
    {
        path: "/maintenanceFund",
        name: "maintenanceFund",
        component: () =>
            import ("@/views/newDemand/maintenanceFund.vue"),
        meta: {
            title: "维修基金查询"
        }
    }, {
        path: "/MaintenanceResult",
        name: "MaintenanceResult",
        component: () =>
            import ("@/views/newDemand/MaintenanceResult.vue"),
        meta: {
            title: "查询结果"
        }
    },
    {
        path: "/consultingService",
        name: "consultingService",
        component: () =>
            import ("@/views/newDemand/consultingService.vue"),
        meta: {
            title: "物业资讯"
        }
    },
    {
        path: "/consultingDetail",
        name: "consultingDetail",
        component: () =>
            import ("@/views/newDemand/consultingDetail.vue"),
        meta: {
            title: "物业详情"
        }
    },
    {
        path: "/commodityConfirm",
        name: "commodityConfirm",
        component: () =>
            import ("@/views/newDemand/commodityConfirm.vue"),
        meta: {
            title: "物业资讯"
        }
    }, {
        path: "/IntegralDetails",
        name: "IntegralDetails",
        component: () =>
            import ("@/views/newDemand/IntegralDetails.vue"),
        meta: {
            title: "积分明细"
        }
    }, {
        path: "/commodityExchange",
        name: "commodityExchange",
        component: () =>
            import ("@/views/newDemand/commodityExchange.vue"),
        meta: {
            title: "积分兑换"
        }
    }, {
        path: "/exchangeRecord",
        name: "exchangeRecord",
        component: () =>
            import ("@/views/newDemand/exchangeRecord.vue"),
        meta: {
            title: "兑换记录"
        }
    }, {
        path: "/officeBuilding",
        name: "officeBuilding",
        component: () =>
            import ("@/views/newDemand/officeBuilding.vue"),
        meta: {
            title: "商铺写字楼"
        }
    }, {
        path: "/consultingNew",
        name: "consultingNew",
        component: () =>
            import ("@/views/newDemand/consultingNew.vue"),
        meta: {
            title: "新闻房产信息"
        }
    }, {
        path: "/lawyer",
        name: "lawyer",
        component: () =>
            import ("@/views/newDemand/lawyer.vue"),
        meta: {
            title: "法律"
        }
    }, {
        path: "/lawyerDetail",
        name: "lawyerDetail",
        component: () =>
            import ("@/views/newDemand/lawyerDetail.vue"),
        meta: {
            title: "法律"
        }
    },
    {
        path: "/viewCell",
        name: "viewCell",
        component: () =>
            import ("@/views/newDemand/viewCell.vue"),
        meta: {
            title: "查找房子"
        }
    },
    {
        path: "/xcx_jump",
        name: "xcx_jump",
        component: () =>
            import ("@/views/newDemand/xcx_jump.vue"),
        meta: {
            title: "黄山街道"
        }
    },
    {
        path: "/questionnaire",
        name: "questionnaire",
        component: () =>
            import ("@/views/newDemand/questionnaire.vue"),
        meta: {
            title: "问卷"
        }
    }, {
        path: "/chaoshi",
        name: "chaoshi",
        component: () =>
            import ("@/views/newDemand/chaoshi.vue"),
        meta: {
            title: "房源超市"
        }
    }
]
export default newDemand;